<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        {{year}} © {{ wl.footerText || wl.appName }}.
      </div>
    </div>
  </div>
</footer>
